import { createWorkbookFromTable } from "../../utils/table_export";

/** Книга Excel для отчёта «Оплаты». Разбор общий для всех отчётов. */
export function createPaymentsWorkbook(table) {
  return createWorkbookFromTable(table);
}
